import { cn } from 'utils/style-utils';

interface IInfoRowProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  value?: string;
  titleSuffix?: React.ReactNode;
  valueClassName?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
  wrapperClassName?: string;
  valueWrapperClassName?: string;
}

const InfoRow = ({
  icon: Icon,
  title,
  value,
  titleSuffix,
  valueClassName = 'text-xs text-neutral-800 w-54 max-w-fit truncate',
  wrapperClassName,
  children,
  isLoading,
  valueWrapperClassName,
}: IInfoRowProps) => (
  <div className={cn('flex gap-3 overflow-hidden', wrapperClassName)}>
    <div className="size-10 rounded-full bg-neutral-100 flex items-center justify-center shrink-0">
      <Icon className="size-4" />
    </div>

    <div className="flex-1 flex flex-col overflow-hidden">
      <p className="text-xs text-gray-700">{title}</p>

      <div
        className={cn(
          'flex items-start justify-between gap-2',
          valueWrapperClassName,
        )}
      >
        {isLoading ? (
          <div className="h-4 w-32 rounded bg-neutral-300 animate-pulse" />
        ) : (
          (children ?? <p className={valueClassName}>{value}</p>)
        )}

        {!isLoading && titleSuffix}
      </div>
    </div>
  </div>
);

export default InfoRow;
